





























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import ImgPreview from "@/components/common/upload/ImgPreview.vue";
import ProfileImgUploader from "@/components/common/upload/ProfileImgUploader.vue";
import BannerImgUploader from "@/components/common/upload/BannerImgUploader.vue";

@Component({
    computed: { ...mapGetters(["user"]) },
    components: { ImgPreview, ProfileImgUploader, BannerImgUploader },
    mixins: [validationMixin],
    validations: {
        form: {
            groupName: {
                required,
                maxLength: maxLength(50),
            },
            groupUrl: {
                required,
                maxLength: maxLength(50),
            },
            description: {
                required,
                maxLength: maxLength(2000),
            },
        },
    },
})
export default class CommunityCreate extends Vue {
    private form = {
        groupName: "",
        groupUrl: "",
        description: "",
        bannerImgSrc: "",
        profileImgSrc: "",
    };

    private user!: any;
    private isPrivate: boolean = false;


    validateState(name) {
        const { $dirty, $error } = this.$v.form[name]!;
        return $dirty ? !$error : null;
    }

    async createCommunity() {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
            return;
        }
        // const result = await this.$api.createCommunity(
        //     this.user.uid,
        //     this.form.groupName,
        //     this.form.groupUrl,
        //     this.form.description,
        //     this.isPrivate,
        //     this.form.profileImgSrc,
        //     this.form.bannerImgSrc
        // );
        //
        // console.log(result);
    }
    getBannerImgSrc(imgSrc: string) {
        this.form.bannerImgSrc = imgSrc;
    }
    getProfileImgSrc(imgSrc: string) {
        this.form.profileImgSrc = imgSrc;
    }
}
